const IS_LOGGING_ENABLED =
  process.env.REACT_APP_ENABLE_API_LOGGING === "true" ||
  process.env.NODE_ENV === "development"

const LEVELS = { debug: 0, info: 1, warn: 2, error: 3 }
const MIN_LEVEL = LEVELS[process.env.REACT_APP_LOG_LEVEL] ?? LEVELS.info

const shouldLog = level => IS_LOGGING_ENABLED && LEVELS[level] >= MIN_LEVEL

const logger = {
  debug: (...args) => {
    if (shouldLog("debug")) console.debug("[DEBUG]", ...args)
  },
  info: (...args) => {
    if (shouldLog("info")) console.info("[INFO]", ...args)
  },
  warn: (...args) => {
    if (shouldLog("warn")) console.warn("[WARN]", ...args)
  },
  error: (...args) => {
    // Errors are always logged regardless of the logging flag
    console.error("[ERROR]", ...args)
  },
}

export default logger
